import React, { useMemo } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { playSound } from '../lib/soundEffects';

const { FiTag, FiX } = FiIcons;

export default function TagFilterBar({
  data = {},
  selectedTag = null,
  onSelectTag,
  themeColors: tc = {},
  isDark: isDarkProp,
}) {
  const isDark = isDarkProp !== undefined
    ? Boolean(isDarkProp)
    : !tc?.card?.toLowerCase().includes('ffffff') && !tc?.card?.startsWith('rgba(255');

  const tags = useMemo(() => {
    const counts = {};
    Object.values(data).forEach((f) => {
      (f.items || []).forEach((item) => {
        if (item.type === 'link') {
          const text = `${item.title || ''} ${item.note || ''}`;
          const matches = text.match(/#([a-zA-Z0-9_\-]+)/g);
          if (matches) {
            matches.forEach((t) => {
              const clean = t.toLowerCase();
              counts[clean] = (counts[clean] || 0) + 1;
            });
          }
        }
      });
    });

    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 15);
  }, [data]);

  if (tags.length === 0) return null;

  return (
    <div className="w-full max-w-2xl flex items-center gap-1.5 overflow-x-auto py-1 mb-4 no-scrollbar">
      <button
        onClick={() => { playSound('click'); onSelectTag(null); }}
        className={`px-2.5 py-1 rounded-lg text-[11px] font-semibold transition-all shrink-0 flex items-center gap-1 cursor-pointer ${
          !selectedTag
            ? isDark
              ? 'bg-white/15 text-white shadow-xs'
              : 'bg-slate-900 text-white shadow-xs'
            : isDark
              ? 'text-[#777] hover:text-white bg-white/5'
              : 'text-slate-500 hover:text-slate-900 bg-slate-100'
        }`}
      >
        <SafeIcon icon={FiTag} className="w-2.5 h-2.5" />
        <span>All</span>
      </button>

      {tags.map(([tag, count]) => {
        const isSelected = selectedTag === tag;
        return (
          <button
            key={tag}
            onClick={() => { playSound('click'); onSelectTag(isSelected ? null : tag); }}
            className={`px-2.5 py-1 rounded-lg text-[11px] font-medium transition-all shrink-0 flex items-center gap-1.5 cursor-pointer border ${
              isSelected
                ? 'bg-cyan-500/20 text-cyan-400 border-cyan-500/40 shadow-sm'
                : isDark
                  ? 'bg-[#181820] text-[#888] hover:text-white border-[#262630]'
                  : 'bg-slate-100 text-slate-600 hover:text-slate-900 border-slate-200'
            }`}
          >
            <span>{tag}</span>
            <span className="text-[9px] opacity-60">({count})</span>
            {isSelected && (
              <SafeIcon icon={FiX} className="w-2.5 h-2.5 ml-0.5" />
            )}
          </button>
        );
      })}
    </div>
  );
}
